
;(function () {

    TrafficSourceCtrl.$inject = ['$scope', '$timeout', '$filter', 'request'];
    angular
        .module('DSSXAPP')
        .component('trafficSource', {
            template:'<section class="data-admin-traffic-source"><div><h3>流量来源</h3><span>店铺切换 <i class="iconfont icon-moreunfold"></i></span><div>过滤中国流量<div></div></div></div><div class="data-admin-traffic-source-anchor"><div></div><div><span ng-click="vm.f.toggleShowDateWeekSelector(true)"><i class="iconfont icon-calendar"></i> {{vm.c.curSelectedResult}}&nbsp;PST <i class="iconfont icon-moreunfold"></i></span> <button ng-class="{\'disabled\': vm.c.curSelected >= vm.c.selectedRange[vm.c.curSelectedType].max}" ng-disabled="vm.c.curSelected >= vm.c.selectedRange[vm.c.curSelectedType].max || vm.c.pending" ng-click="vm.f.stepSelect(false)"><i class="iconfont icon-back"></i></button> <button ng-class="{\'disabled\': vm.c.curSelected <= vm.c.selectedRange[vm.c.curSelectedType].min}" ng-disabled="vm.c.curSelected <= vm.c.selectedRange[vm.c.curSelectedType].min || vm.c.pending" ng-click="vm.f.stepSelect(true)"><i class="iconfont icon-more"></i></button><div class="data-admin-traffic-source-day-week-selector" ng-show="vm.c.showDateWeekSelector"><div class="data-admin-traffic-source-day-week-selector-panel"><ul><li ng-repeat="stats in vm.c.statsMenus track by $index" ng-attr-id="{{stats.btnId}}" ng-click="vm.f.selectDateWeekType(stats, $index, $event)" ng-class="{\'current\': vm.c.curStatsIndex === $index}">{{stats.title}} <label><input ng-attr-id="{{stats.dateId}}"></label></li></ul><div><div ng-attr-id="{{vm.c.statsMenus[0].dateId}}" ng-show="vm.c.curStatsIndex === 0"></div><date-week max="vm.c.curDate" week-range="vm.c.weekRange" on-change="vm.f.weekChange($event)" ng-click="$event.stopPropagation()" ng-show="vm.c.curStatsIndex === 1"></date-week><div ng-attr-id="{{vm.c.statsMenus[2].dateId}}" ng-show="vm.c.curStatsIndex === 2"></div></div></div></div><div class="data-admin-traffic-source-mask" ng-show="vm.c.showDateWeekSelector" ng-click="vm.f.toggleShowDateWeekSelector(false)"></div></div></div><div class="data-admin-traffic-source-visit-detail">流量来源</div><div class="data-admin-traffic-source-overview-block"><table><thead><tr><th>流量来源</th><th>店铺访问人数 <i class="iconfont icon-help" id="shop-uv-tip"></i></th><th>店铺询盘人数 <i class="iconfont icon-help" id="fb-mc-uv-tip"></i></th><th>店铺TM咨询人数 <i class="iconfont icon-help" id="fb-uv-tip"></i></th><th>店铺转化率 <i class="iconfont icon-help" id="visitor-to-fb-rate-tip"></i></th><th>操作</th></tr></thead><tbody><tr ng-repeat="data in vm.d.list track by $index"><td>{{data.channel_type_display}}</td><td><div><span>{{data.shop_uv}}</span><div ng-class="{\'comparative-up\': data.shop_uv_lrrate > 0, \'comparative-none\': data.shop_uv_lrrate === 0, \'comparative-down\': data.shop_uv_lrrate < 0}"><div>➞</div><span>{{data.shop_uv_lrrate}}%</span></div></div></td><td><div><span>{{data.fb_mc_uv}}</span><div ng-class="{\'comparative-up\': data.fb_mc_uv_lrrate > 0, \'comparative-none\': data.fb_mc_uv_lrrate === 0, \'comparative-down\': data.fb_mc_uv_lrrate < 0}"><div>➞</div><span>{{data.fb_mc_uv_lrrate}}%</span></div></div></td><td><div><span>{{data.fb_uv}}</span><div ng-class="{\'comparative-up\': data.fb_uv_lrrate > 0, \'comparative-down\': data.fb_uv_lrrate < 0}"><div>➞</div><span>{{data.fb_uv_lrrate}}%</span></div></div></td><td><div><span>{{data.visitor_to_fb_rate}}</span><div ng-class="{\'comparative-up\': data.visitor_to_fb_rate_lrrate > 0, \'comparative-none\': data.visitor_to_fb_rate_lrrate === 0, \'comparative-down\': data.visitor_to_fb_rate_lrrate < 0}"><div>➞</div><span>{{data.visitor_to_fb_rate_lrrate}}%</span></div></div></td><td><a href="javascript:;">趋势</a></td></tr></tbody></table></div></section>',
            bindings: {},
            controllerAs: 'vm',
            controller: TrafficSourceCtrl
        });

    function TrafficSourceCtrl($scope, $timeout, $filter, request) {
        var vm = this,
            DAY_TIMES_TAMP = 24 * 3.6e3 * 1e3,
            weekRangeAttrs = [],
            weekRangeContents = [],
            triggerCount = 0,
            validMonthRange = {
                min: '',
                max: new Date(DSSX.util.getServerCurrentTime().getFullYear() + '-' + (DSSX.util.getServerCurrentTime().getMonth() + 1) + '-01' + ' 00:00:00').getTime() - 1000
            },
            store = {
                monthPlugin: {
                    lastChange: {
                        year: NaN,
                        month: NaN
                    }
                }
            };

        vm.c = {
            ts: DAY_TIMES_TAMP,
            selectedRange: {
                day: {
                    min: 1,
                    max: 90
                },
                week: {
                    min: 1,
                    max: 12
                },
                month: {
                    min: 1,
                    max: 3
                }
            },
            curSelected: 1,
            curSelectedType: 'day',
            curSelectedResult: '',
            weekRange: {},
            curStatsIndex: 0,
            statsMenus: [ // 统计菜单
                {
                    title: '天',
                    btnId: 'day-btn',
                    dateId: 'date-day',
                    type: 'date',
                    min: '2017-8-30',
                    max: '2017-11-29',
                    lang: 'en',
                    oldValue: '2017-11-28'
                },
                {
                    title: '周',
                    btnId: 'week-btn',
                    dateId: 'date-week',
                    type: 'week',
                    min: '2017-8-30',
                    max: '2017-11-29',
                    lang: 'en'
                },
                {
                    title: '月',
                    btnId: 'month-btn',
                    dateId: 'date-month',
                    type: 'month',
                    min: '2017-8-1',
                    max: '2017-10-31',
                    lang: 'cn',
                    oldValue: '2017-10'
                }
            ],
            showDateWeekSelector: false,
            pending: false,
            curDate: new Date(DSSX.util.getServerCurrentTime().getTime() - DAY_TIMES_TAMP * 2),
        };

        vm.d = {
            list: []
        };

        vm.f = {
            getBusinessData: getBusinessData,
            weekChange: weekChange,
            selectDateWeekType: selectDateWeekType,
            toggleShowDateWeekSelector: toggleShowDateWeekSelector,
            stepSelect: stepSelect,
        };

        $scope.$watch('vm.c.weekRange', function (newVal) {
            vm.c.weekRange = newVal;
            weekRangeAttrs = [];
            for (var attr in vm.c.weekRange) {
                if (!vm.c.weekRange.hasOwnProperty(attr)) {
                    continue;
                }
                weekRangeAttrs.unshift(attr);
                weekRangeContents = weekRangeContents.concat([].concat(vm.c.weekRange[attr]).reverse());
                validMonthRange.min = new Date(attr + '-01 00:00:00').getTime();
            }
        });

        init();

        function init() {
            console.log('[TrafficSourceCtrl init: ]');

            $timeout(function () {
                initTips();
                initVM();
                getBusinessData(1, 'day', $filter('date')(vm.c.curDate, 'yyyy-MM-dd'));
            });
        }

        function initVM() {
            var max = vm.c.curDate.getTime();
            var min = max - DAY_TIMES_TAMP * (vm.c.selectedRange.day.max - 1);
            var minDate = $filter('date')(new Date(min), 'yyyy-MM-dd'); // 当前年月日
            var maxDate = $filter('date')(new Date(max), 'yyyy-MM-dd'); // 当前年月日
            for (var i = 0; i < vm.c.statsMenus.length; i++) {
                if (vm.c.statsMenus[i].type !== 'month') {
                    vm.c.statsMenus[i].min = minDate;
                    vm.c.statsMenus[i].max = maxDate;
                    vm.c.statsMenus[i].oldValue = $filter('date')(vm.c.curDate, 'yyyy-MM-dd');
                } else {
                    var minYM = minDate.slice(0, -3);
                    var minD = minYM + '-01';
                    var maxYear = new Date(max).getFullYear();
                    var maxMonth = new Date(max).getMonth();
                    var maxD = maxYear + '-' + maxMonth + '-28';

                    vm.c.statsMenus[i].min = minD;
                    vm.c.statsMenus[i].max = maxD;
                    vm.c.statsMenus[i].oldValue = maxYear + '-' + maxMonth;
                }
            }
        }

        function initTips() {
            showTip("#shop-uv-tip", "#shop-uv-tip", "访问供应商店铺页面的用户均被记为店铺访客，包含中国大陆地区的数据");
            showTip("#fb-mc-uv-tip", "#fb-mc-uv-tip", "在供应商店铺页面，对您成功发起有效询盘的买家数量。");
            showTip("#fb-uv-tip", "#fb-uv-tip", "在供应商店铺页面，通过TradeManager与您联系的买家数（不含APP端）。");
            showTip("#visitor-to-fb-rate-tip", "#visitor-to-fb-rate-tip", "（店铺TM咨询人数+店铺询盘人数）/店铺访客数");
        }

        function showTip(target, anchor, msg) {
            var id;
            $(target).hover(function () {
                id = layer.tips('<span style="color: #333333;">' + msg + '</span>', anchor, {
                    tips: [3, '#ffffff'],
                    time: 2000000
                });
            }, function () {
                layer.close(id);
            });
        }

        /**
         * @param argSelected number
         * @param argType string
         * @param argDate string
         */
        function getBusinessData(argSelected, argType, argDate) {
            if (vm.c.pending) {
                return;
            }

            if (argType !== 'day' && argType !== 'week' && argType !== 'month') {
                DSSX.dialog.msg('无效的数据类型');
                return;
            }

            if (argSelected < vm.c.selectedRange[argType].min || argSelected > vm.c.selectedRange[argType].max) {
                DSSX.dialog.msg('超出时间范围');
                return;
            }

            vm.c.pending = true;
            request.get('/pub/api/loadBizData', {
                type: 'flow_source',
                statisticsType: argType,
                selected: argSelected
            }).then(function (res) {
                vm.c.curSelected = argSelected;
                vm.c.curSelectedType = argType;
                vm.c.curSelectedResult = argDate;
                vm.d.list = [];
                DSSX.util.safe(res, 'data.flowSource', []).forEach(function (value) {
                    this.push({
                        channel_type_display: value.channel_type_display || '-',
                        shop_uv: value.shop_uv || 0,
                        shop_uv_lrrate: value.shop_uv_lrrate || 0,
                        fb_mc_uv: value.fb_mc_uv || 0,
                        fb_mc_uv_lrrate: value.fb_mc_uv_lrrate || 0,
                        fb_uv: value.fb_uv || 0,
                        fb_uv_lrrate: value.fb_uv_lrrate || 0,
                        visitor_to_fb_rate: value.visitor_to_fb_rate || '-',
                        visitor_to_fb_rate_lrrate: value.visitor_to_fb_rate_lrrate || 0
                    });
                }, vm.d.list);
            }, function (err) {
                DSSX.dialog.err(err, {
                    moduleName: '[diagnosis-center.js]',
                    funcName: 'getBusinessData',
                    text: '获取数据失败'
                });
            }).finally(function () {
                vm.c.pending = false;
            });
        }

        /**
         * @param argValue boolean
         */
        function toggleShowDateWeekSelector(argValue) {
            vm.c.showDateWeekSelector = argValue;
            $timeout(function () {
                argValue && triggerCount === 0 && $('.data-admin-traffic-source-day-week-selector-panel > ul > li.current').trigger('click');
                argValue && triggerCount++;
            });
        }

        /**
         * 周日历变化事件
         * @param weekRange {start,end}
         */
        function weekChange(weekRange) {
            var curTime = new Date(vm.c.curDate.getTime());
            var curDay = '0123456'.charAt(curTime.getDay()); // 获得当前时间为周几
            var dateEnd = curTime - DAY_TIMES_TAMP * (+curDay + 1);
            var selected = (((dateEnd - (new Date(weekRange.end))) / (DAY_TIMES_TAMP * 7))) + 1;

            console.log(selected);
            toggleShowDateWeekSelector(false);
            getBusinessData(Math.round(selected), 'week', weekRange.start + '至' + weekRange.end);
        }

        /**
         * @param stats object
         * @param index number
         * @param e event
         */
        function selectDateWeekType(stats, index, e) {
            if (!(index in vm.c.statsMenus)) {
                return;
            }
            vm.c.curStatsIndex = index;

            removeLayDate();
            if (stats.type === 'week') {
                e.stopPropagation();
                return;
            }

            $timeout(function () {
                var selector = '#' + stats.dateId;
                $(selector).val(stats.oldValue);
                laydate.render({
                    elem: selector,
                    theme: 'b',
                    type: stats.type,
                    lang: stats.lang,
                    // value: stats.oldValue,
                    show: true, //直接显示
                    showBottom: false,
                    min: stats.min,
                    max: stats.max,
                    closeStop: '#' + stats.btnId, //这里代表的意思是：点击 test1 所在元素阻止关闭事件冒泡。如果不设定，则无法弹出控件
                    position: 'static',
                    ready: function (value, date) { // 控件打开的时候触发

                    },
                    change: function (value, date, endDate) { // 切换年月的时候触发 要判断是日期选择器还是年月选择器触发 日期 value='2017-08-09' 年月 value='2017-08'

                        if (value.length > 7) {
                            return;
                        }

                        /**
                         * 这里由于点击两边的按钮切换年月时，
                         * 如果时间在合理范围内会直接请求数据，
                         * 然后关闭日历插件，
                         * 所以点击左右两边的按钮时直接return，
                         * 点击具体的年月时请求数据，
                         * 根据判断 上次变化月份 === 点击的月份 上次变化的年份 !== 点击的年份
                         * 来区别是点击具体的年月还是点击两边的按钮来触发的事件
                         */
                        var preLastChange = store.monthPlugin.lastChange;

                        store.monthPlugin.lastChange = {
                            year: date.year,
                            month: date.month
                        };

                        if (preLastChange.month === date.month) {
                            if (preLastChange.year !== date.year) {
                                return;
                            }
                        }

                        var curTime = new Date(value).getTime();
                        if (curTime < validMonthRange.min || curTime > validMonthRange.max) {
                            return;
                        }

                        var selected;
                        switch (value) {
                            case weekRangeAttrs[0]:
                                selected = 3;
                                break;
                            case weekRangeAttrs[1]:
                                selected = 2;
                                break;
                            case weekRangeAttrs[2]:
                                selected = 1;
                                break;
                            default:
                                selected = 1;
                        }

                        toggleShowDateWeekSelector(false);
                        getBusinessData(selected, 'month', value);
                    },
                    done: function (value, date, endDate) { // 日期选择完毕触发
                        $timeout(function () {
                            var curTime = new Date(vm.c.curDate.getTime());
                            var selectedTime = new Date(value);
                            selectedTime.setHours(0);
                            var selected = Math.floor(((curTime - selectedTime) / DAY_TIMES_TAMP));
                            var type = stats.type === 'date' ? 'day' : 'month';

                            toggleShowDateWeekSelector(false);
                            getBusinessData(selected + 1, type, $filter('date')(selectedTime.getTime(), 'yyyy-MM-dd'));
                        });
                    }
                });
            })
        }

        // 移除laydate
        function removeLayDate() {
            // 如果存在 laydate 则remove
            var laydateEle = $('.laydate-theme-b');
            if (laydateEle.length) {
                for (var i = 0; i < laydateEle.length; i++) {
                    laydateEle[i].remove();
                }
            }
        }

        /**
         * 前后点击
         * @param argNext boolean
         */
        function stepSelect(argNext) {
            getBusinessData(argNext ? vm.c.curSelected - 1 : vm.c.curSelected + 1,
                vm.c.curSelectedType,
                getSelectedResult(argNext ? (vm.c.curSelected - 1) : (vm.c.curSelected + 1), vm.c.curSelectedType));
        }

        /**
         * @param argSelected number
         * @param argType string
         * @returns {string|*}
         */
        function getSelectedResult(argSelected, argType) {
            var res = '',
                date = new Date(vm.c.curDate.getTime());

            switch (argType) {
                case 'day':
                    res = $filter('date')(vm.c.curDate - (argSelected - 1) * DAY_TIMES_TAMP, 'yyyy-MM-dd');
                    break;
                case 'week':
                    var curDay = '0123456'.charAt(date.getDay());
                    var dateEnd = date - DAY_TIMES_TAMP * (+curDay + 1);
                    var dateStart = dateEnd - DAY_TIMES_TAMP * 6;

                    res = $filter('date')(dateStart - (argSelected - 1) * DAY_TIMES_TAMP * 7, 'yyyy-MM-dd') + '至' + $filter('date')(dateEnd - (argSelected - 1) * DAY_TIMES_TAMP * 7, 'yyyy-MM-dd');
                    break;
                case 'month':
                    res = $filter('date')(date.setMonth(date.getMonth() - argSelected), 'yyyy-MM');
                    break;
                default:
                    return '';
            }

            return res;
        }
    }
})();
